export default __webpack_public_path__ + "static/media/code1.6c1b8aa5.png";